import m, {MithrilComponent} from '@bitstillery/mithril'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const imageMeta = {
    tier: 'content',
    summary: 'A single content image constrained to its column.',
    when_to_use: 'Pass a plain URL the browser can load — a media-library `public_url`, a static `/img/…`, or an external URL.',
    example: `
    <Image alt="Bottle with a blank label" url="/common/img/catalog/example-placeholder.jpg" />
    `,
} satisfies CmsComponentMeta

export interface ImageAttrs {
    /** Image URL — media library, static bundle (`/img/…`), or external. Plain string the browser loads. */
    url: string
    alt: string
}

/** A single content image (plain `<img>`, constrained to its column width). */
export class Image extends MithrilComponent<ImageAttrs> {
    view(vnode: m.Vnode<ImageAttrs>) {
        return <img className='c-image' src={vnode.attrs.url} alt={vnode.attrs.alt} />
    }
}
